<template>
  <v-alert
    v-bind="$attrs"
    :value="alert"
    class="bm-headline"
    :type="type"
    :color="
      color ||
      (appStore.state.theme === 'dark' && type === 'error'
        ? 'errorMedium'
        : undefined)
    "
  >
    <slot />
    <template v-if="dismissible" #close>
      <div
        class="button"
        role="button"
        tabindex="0"
        @click="
          alert = false;
          $emit('dismiss');
        "
      >
        <v-icon data-qa="close_alert">close</v-icon>
      </div>
    </template>
    <template v-if="dismissible" #prepend>
      <slot name="prepend"></slot>
    </template>
  </v-alert>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import appStore from "@/store/modules/appStore";

export default defineComponent({
  name: "BmAlert",
  props: {
    dismissible: {
      type: Boolean,
      default: false,
      required: false,
    },
    type: {
      type: String,
      required: false,
    },
    color: {
      type: String,
      required: false,
    },
    closeIconColour: {
      type: String,
      required: false,
    },
  },
  setup() {
    return {
      alert: ref(true),
      appStore,
    };
  },
});
</script>

<style lang="sass">
@import "src/sass/colours"

.v-alert
  color: white !important
  border-width: 3px
  align-items: flex-start

.v-alert.warning, .warningMedium
  color: $bm-color-text01 !important
  border-width: 3px

.v-alert .button
  cursor: pointer
  align-self: flex-start

.v-alert a
  color: white !important
  text-decoration: underline

.v-alert.warning a, .warningMedium a
  color: $bm-color-text01 !important

.v-alert
  word-break: normal
  overflow-wrap: anywhere
</style>
